/** 詳細ページ・右パネルの中の白いカード(見出し + 右端の操作 + 本文)。 */
import type { ReactNode } from "react";

export function Section({
  title,
  extra,
  flush = false,
  children,
}: {
  title: ReactNode;
  extra?: ReactNode;
  /** 本文の余白を無くす(表をそのまま入れるとき) */
  flush?: boolean;
  children: ReactNode;
}) {
  return (
    <section className="ui-section">
      <div className="ui-section-head">
        <h2>{title}</h2>
        {extra}
      </div>
      <div className={`ui-section-body${flush ? " is-flush" : ""}`}>{children}</div>
    </section>
  );
}
